import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 28 28"
    }, props), {
        style: {
            borderRadius: "8px"
        },
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "28",
                height: "28",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2.45001C7.58334 2.45001 2.33334 7.70001 2.33334 14.1167C2.33334 16.3333 2.91668 18.4333 3.96668 20.1833L6.30001 17.6167C5.01668 16.5667 4.08334 14.9333 4.08334 13.0667C4.08334 11.2 5.01668 9.45001 6.30001 8.40001V7.11668H10.0333C11.55 7.11668 12.8333 7.70001 13.8833 8.51668C14.9333 7.58335 16.3333 7.11668 17.7333 7.11668H21.4667V8.40001C22.8667 9.45001 23.6833 11.2 23.6833 13.0667C23.6833 15.4 22.2833 17.5 20.3 18.4333C19.6 20.5333 18.2 22.4 16.45 24.0333V25.55C21.7 24.3833 25.55 19.7167 25.55 14.1167C25.6667 7.70001 20.4167 2.45001 14 2.45001V2.45001Z",
                fill: "black"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.15 14.8166C11.2 14.8166 12.0167 14 12.0167 12.95C12.0167 11.9 11.2 11.0833 10.15 11.0833C9.09999 11.0833 8.28333 11.9 8.28333 12.95C8.28333 14 9.09999 14.8166 10.15 14.8166Z",
                fill: "black"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.85 14.9333C18.8809 14.9333 19.7167 14.0976 19.7167 13.0667C19.7167 12.0357 18.8809 11.2 17.85 11.2C16.8191 11.2 15.9833 12.0357 15.9833 13.0667C15.9833 14.0976 16.8191 14.9333 17.85 14.9333Z",
                fill: "black"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.15 17.6167C11.2 17.6167 12.25 17.2667 12.95 16.5667L14 18.9L15.05 16.5667C15.8667 17.15 16.8 17.6167 17.85 17.6167C20.4167 17.6167 22.4 15.5167 22.4 13.0667C22.4 10.6167 20.3 8.51669 17.85 8.51669C16.2167 8.51669 14.8167 9.33336 14 10.6167C13.1833 9.33336 11.7833 8.40002 10.15 8.40002C7.58334 8.40002 5.60001 10.5 5.60001 12.95C5.60001 15.4 7.58334 17.6167 10.15 17.6167ZM17.85 9.80002C19.6 9.80002 21 11.2 21 12.95C21 14.7 19.6 16.1 17.85 16.1C16.1 16.1 14.7 14.7 14.7 12.95C14.7 11.2 16.1 9.80002 17.85 9.80002V9.80002ZM7.00001 13.0667C7.00001 11.3167 8.40001 9.91669 10.15 9.91669C11.9 9.91669 13.3 11.3167 13.3 13.0667C13.3 14.8167 11.9 16.2167 10.15 16.2167C8.40001 16.2167 7.00001 14.8167 7.00001 13.0667Z",
                fill: "black"
            })
        ]
    }));
};
export default Icon;
